import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { AgregarDomicilioDependenciaParams, AgregarDomicilioDependenciaResponse, defaultAgregarDomicilioDependencia, defaultDependencia, DependenciaProps } from '../../interfaces/catalogos/DependenciaInterface';
import { DomicilioProps } from '../../interfaces/comun/DomicilioInterface';

export const Dependencias = () => {

    return new Promise<DependenciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Dependencia/', token)
            .then( ({ data } : { data : DependenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ObtenerDependencias = () => {

    return new Promise<DependenciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Dependencia/ObtenerDependencias', token)
            .then( ({ data } : { data : DependenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ObtenerDependencia = ( id: number ) => {

    return new Promise<DependenciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Dependencia/ObtenerDependencia/${ id }`, token)
            .then( ({ data } : { data : DependenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ActualizarDependencia = ( params: DependenciaProps ) => {

    return new Promise<DependenciaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Dependencia/Actualizar', params, token)
            .then( ({ data } : { data : DependenciaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultDependencia } );
            });

        }

    });

}

export const AgregarDependencia = ( params: DependenciaProps ) => {

    return new Promise<DependenciaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Dependencia/Agregar', params, token)
            .then( ({ data } : { data : DependenciaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultDependencia } );
            });

        }

    });

}

export const ObtenerDomicilioDependencia = ( id: number ) => {

    return new Promise<DomicilioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Dependencia/ObtenerDomicilioDependencia/${ id }`, token)
            .then( ({ data } : { data : DomicilioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const AgregarDomicilioDependencia = ( params: AgregarDomicilioDependenciaParams ) => {

    return new Promise<AgregarDomicilioDependenciaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Dependencia/AgregarDomicilioDependencia', params, token)
            .then( ({ data } : { data : AgregarDomicilioDependenciaResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultAgregarDomicilioDependencia, message: error.message } );
            });

        }

    });

}
